import React from 'react'
import { MessageContainer } from '../../elements/MessageElement'

function MessageAlert({alert, msg, mrb}) {

    return (
        <MessageContainer alert={alert} mrb={mrb}>
            <span>{msg}</span>
        </MessageContainer>
    )
}

export default MessageAlert